(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/chat-component.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/chat-component.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const socketMockable = svs.components.lbUtils.socket;
const chatUiMockable = svs.components.chat.chatUi;
const Button = svs.ui.ReactButton;
const logger = svs.components.chat.chatUi.logger;
const _svs$components$chat$ = svs.components.chat.chatData,
  actions = _svs$components$chat$.actions,
  helpers = _svs$components$chat$.helpers,
  constants = _svs$components$chat$.constants;
const ROOM_STATUS_OPEN = constants.ROOM_STATUS_OPEN,
  MAX_CHARACTER_COUNT = constants.MAX_CHARACTER_COUNT;
const ChatComponent = _ref => {
  let isAlwaysVisible = _ref.isAlwaysVisible,
    customerId = _ref.customerId,
    roomId = _ref.roomId,
    children = _ref.children,
    isRetail = _ref.isRetail;
  const dispatch = useDispatch();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubscribed = _useState2[0],
    setSubscribed = _useState2[1];
  const hasLogged = useRef(false);
  const messageListRef = useRef();

  const room = useSelector(state => state.Chat.rooms[roomId] || {
    newMessage: '',
    loading: false,
    error: null,
    everything: false
  });
  const messageList = useSelector(state => helpers.getMessageListForRoom(roomId, state.Chat));
  const isVisible = useSelector(state => isAlwaysVisible || state.Chat.isOpen);
  const isEnabled = useSelector(state => (state.Chat.rooms[roomId] || {}).status === ROOM_STATUS_OPEN);
  const isCurrentUserAuthenticated = useSelector(state => state.customerId !== null);

  const onResendMessage = localId => dispatch(actions.retrySendMessage(roomId, localId));
  const onSubmitMessage = message => dispatch(actions.sendMessageToRoom(message, roomId));
  const onDeleteMessage = messageId => dispatch(actions.deleteMessage(messageId, roomId));
  const onDeleteQueuedMessage = localId => dispatch(actions.deleteQueuedMessage(localId, roomId));
  const onFetchMessages = useCallback(options => dispatch(actions.fetchMessagesByRoomId(roomId, options)), [dispatch, roomId]);
  const onSocketUpdate = useCallback(response => dispatch(actions.socketReceiveMessage(roomId, response)), [dispatch, roomId]);
  const onInitializeComponent = useCallback(() => dispatch({
    type: actions.CHAT_INITIALIZE_COMPONENT_STATE,
    customerId
  }), [customerId, dispatch]);
  const newServerMsgs = messageList.filter(m => !m.localId);
  const newLastId = (newServerMsgs.pop() || {}).id;
  const error = room.error,
    hasLoadedEverything = room.hasLoadedEverything,
    isUserBlocked = room.isUserBlocked,
    loading = room.loading,
    newMessage = room.newMessage;
  useEffect(() => {
    onInitializeComponent();
  }, [onInitializeComponent]);
  useEffect(() => {
    if (isVisible && newLastId) {
      dispatch(actions.markRead(newLastId, roomId));
    }
  }, [dispatch, isVisible, newLastId, roomId]);
  useEffect(() => {
    if (!hasLogged.current) {
      messageList.length > 100 && logger.warn("Client has many messages, roomId: ".concat(roomId, ", ").concat(messageList.length, " "));
      hasLogged.current = true;
    }
  }, [messageList, roomId]);
  function handleOnChange() {
    messageListRef.current.scrollToBottom();
  }
  const handleSignIn = () => {
    svs.components.customer_login.login();
  };
  const handleSocketUpdate = useCallback(function () {
    onSocketUpdate(...arguments);
    if (!isSubscribed) {
      if (isCurrentUserAuthenticated) {
        onFetchMessages({
          reset: true,
          fetchRoom: isCurrentUserAuthenticated
        });
        dispatch(actions.getUnreadByRoom(roomId));
      }
      setSubscribed(true);
    }
  }, [dispatch, isCurrentUserAuthenticated, isSubscribed, onFetchMessages, onSocketUpdate, roomId]);
  const validationError = helpers.validateChatMessage(newMessage, MAX_CHARACTER_COUNT);
  return React.createElement(socketMockable.Socket, {
    onUpdate: handleSocketUpdate,
    path: "/chat/1/rooms/".concat(isRetail ? 'retailer/' : '').concat(roomId, "/messages/changes"),
    sendInitialUpdate: true
  }, _ref2 => {
    let socketError = _ref2.error,
      retryReconnect = _ref2.retryReconnect;
    if (!isCurrentUserAuthenticated) {
      return React.createElement("aside", {
        "aria-label": "Chatt",
        className: "chat-container qa-chat-container",
        tabIndex: "-1"
      }, children, React.createElement("div", {
        className: "padding-1 f-100 align-center fc-navy"
      }, React.createElement("p", null, "Du m\xE5ste logga in f\xF6r att kunna se chatten."), React.createElement(Button, {
        className: "external-prompt-btn",
        inverted: true,
        onClick: handleSignIn,
        size: 300
      }, "LOGGA IN")));
    }
    return React.createElement("aside", {
      "aria-label": "Chatt",
      className: "chat-container qa-chat-container",
      tabIndex: "-1"
    }, children, Boolean(isEnabled) && React.createElement(React.Fragment, null, React.createElement("div", {
      className: "chat-content"
    }, React.createElement(chatUiMockable.MessageList, {
      error: error || socketError && new Error('Kunde inte ansluta till chatten för tillfället'),
      hasLoadedEverything: hasLoadedEverything,
      isCurrentUserAuthenticated: isCurrentUserAuthenticated,
      loading: loading || !isSubscribed && !socketError,
      messageList: messageList,
      onDeleteMessage: onDeleteMessage,
      onDeleteQueuedMessage: onDeleteQueuedMessage,
      onFetchMessages: onFetchMessages,
      onResendMessage: onResendMessage,
      onRetryReconnect: error ? onFetchMessages : retryReconnect,
      ref: messageListRef
    })), Boolean(isUserBlocked) && React.createElement(chatUiMockable.BlockedUser, null), !isUserBlocked && React.createElement(chatUiMockable.WriteMessage, {
      disabled: Boolean(validationError),
      isCurrentUserAuthenticated: isCurrentUserAuthenticated,
      newMessage: newMessage,
      onSubmitMessage: onSubmitMessage,
      onUpdateNewMessage: handleOnChange
    })), !isEnabled && React.createElement("div", {
      className: "padding-1 f-100 align-center fc-navy"
    }, !isRetail ? 'Något gick fel, chatten kunde inte visas.' : 'Butiken har inaktiverat kommentarsfältet.'));
  });
};
setGlobal('svs.components.chat.chatUi.ChatComponent', ChatComponent);

 })(window);